import { CompanyData } from '../../common/types/CompanyData';
import { AccountDataGrid } from '../../accountsGrid/types';
import { AccountSourceId } from '../../common/types/AccountSources';
import { SelectedTargets } from '../../../targets/type';
import { Rights } from '../../common/accountRoleAndPrivileges/type';

export enum EditAccountEvents {
  InitEditAccountForm = 'initEditAccountForm',
  AccountUpdated = 'accountCreated',
  Cancel = 'cancelCreateAccount',
}

export interface EditedAccount extends AccountDataGrid {
  companyInfo: CompanyData;
}

export interface UpdatedAccount {
  _id: string;
  userName: string;
  email: string;
  created: null;
  password: string;
  profile: Profile;
  phoneNumber: PhoneNumber;
  source: AccountSourceId;
  company: Company;
  role: Role;
  accountLockdown?: LockDown;
  passwordLifetime?: boolean;
  twoFactorAuthentication?: {
    enabled: boolean;
  };
  concurrentSessions?: {
    enabled: boolean;
  },
  serviceTargets?: SelectedTargets;
}

interface Profile {
  fullName: string;
  timezone: string;
  language: string;
}

interface PhoneNumber {
  countryCode: string;
  subscriberNumber: string;
}

interface Company {
  id: string;
}

interface Role {
  roleId: string | null;
  rights: Rights;
}

interface LockDown {
  enabled: boolean;
}
